import { render, staticRenderFns } from "./index.page.vue?vue&type=template&id=3054918f&scoped=true&"
import script from "./index.page.vue?vue&type=script&lang=js&"
export * from "./index.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3054918f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3054918f')) {
      api.createRecord('3054918f', component.options)
    } else {
      api.reload('3054918f', component.options)
    }
    module.hot.accept("./index.page.vue?vue&type=template&id=3054918f&scoped=true&", function () {
      api.rerender('3054918f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/outOrder/index.page.vue"
export default component.exports